/**
 * an error that will occur if the attempt at placing an order, or setting up order qty's for a tactic, etc, will go over the 
 * size of the position
 * {
	"messageType": "alertNotification",
	"notificationId": 1645452750654,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ORDER_QTY_MORE_THAN_POSITION_SIZE",
	"statusDetails": {"side":"BTO","quantityBasis":"QUANTITY","restingOrderQty":3.0,"positionQty":2.0,"newOrderQty":5.0,"orderSymbol":"XYZ"},
	"date": "2022-02-21T09:12:31.351-0500",
	"timestamp": "1645452751351"
}

 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) symbol: the symbol this status applies to
 * 2) side: is this order a : BTO/STO/BTC/STC (it will probably be either BTC or STC, bc this 
 * message is saying that there is something wrong with a close attempt)
 * 3) restingOrderQty: the size of the position 
 * 4) newOrderQty: the size of the attempted order
 * 5) quantityBasis: either QUANTITY/PERCENT. QUANTITY would be like in the example above. PERCENT
 * would be if the user is trying to do Underlying Price Exit, and the resulting percentages from the attempted exit
 * go over 100% of the position size. youd get something like the restingOrderQty is 80%, and the newOrderQty is 30%
 */
export function orderQtyMoreThanPositionSizeParser(statusDetails) {
  const parsedObj = {
    symbol: null,
    side: null,
    restingOrderQty: null,
    newOrderQty: null,
    quantityBasis: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.orderSymbol ?? null;
    parsedObj.side = statusDetails.side ?? null;
    parsedObj.restingOrderQty = statusDetails.restingOrderQty ?? null;
    parsedObj.newOrderQty = statusDetails.newOrderQty ?? null;
    parsedObj.quantityBasis = statusDetails.quantityBasis ?? null;
  }

  return parsedObj;
}
